// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__304G2","label":"Category_label__3BMir","content":"Category_content__DNB9E","header":"Category_header__10jwc","location":"Category_location__3rkV8"};